module.exports = __webpack_public_path__ + "d24acbfc9fd6cdf067c31544e4984a24.glb";